import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "colorWrap"
};
const _hoisted_2 = {
  class: "colordisplay"
};
const _hoisted_3 = {
  class: "fillvalue"
};
const _hoisted_4 = {
  class: "colormain"
};
const _hoisted_5 = {
  class: "buttonwarp"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_sketch_picker = _resolveComponent("sketch-picker");
  const _component_RefreshRight = _resolveComponent("RefreshRight");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_vue_gpickr = _resolveComponent("vue-gpickr");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dropdown, {
    trigger: "click",
    ref: "dropdown"
  }, {
    dropdown: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tabs, {
      modelValue: $data.switchtab2,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.switchtab2 = $event),
      class: "switchTab1 small",
      onTabClick: $options.handleClick
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "纯色",
        name: 0
      }), _createVNode(_component_el_tab_pane, {
        label: "线性",
        name: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onTabClick"]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_sketch_picker, {
      modelValue: $data.colors,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.colors = $event)
    }, null, 8, ["modelValue"])], 512), [[_vShow, $data.switchtab2 === 0]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_icon, {
      class: "refreshicon",
      onClick: $options.refreshGradient
    }, {
      default: _withCtx(() => [_createVNode(_component_RefreshRight)]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_vue_gpickr, {
      modelValue: $data.gradient,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.gradient = $event)
    }, null, 8, ["modelValue"])], 512), [[_vShow, $data.switchtab2 === 1]]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
      size: "small",
      plain: "",
      onClick: $options.quithandle
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("取消")])),
      _: 1,
      __: [3]
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      size: "small",
      type: "primary",
      plain: "",
      onClick: $options.okHandle
    }, {
      default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("确定")])),
      _: 1,
      __: [4]
    }, 8, ["onClick"])])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
      class: "fillcolor",
      style: _normalizeStyle({
        'background': $data.fillbackground
      })
    }, null, 4), _createVNode(_component_el_tooltip, {
      class: "box-item",
      content: $data.fillbackground,
      placement: "top-start"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, _toDisplayString($data.fillbackground), 1)]),
      _: 1
    }, 8, ["content"])])]),
    _: 1
  }, 512)]);
}